export const getSavedConfig = (treeGridId: string): string | null => {
  try {
    if (window.localStorage) {
      return window.localStorage.getItem(`TreeGrid${treeGridId}`)
    }
    return null
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error accessing localStorage:", error)
    return null
  }
}
